import {Component, EventEmitter, Input, OnInit, Output, inject} from '@angular/core';
import {DialogService} from "../../../shared/services/dialog.service";
import {Dialog, DialogModule, TooltipModule} from "@syncfusion/ej2-angular-popups";
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";

import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {TYPE} from "../../../shared/types/types";
import {DropDownListModule} from "@syncfusion/ej2-angular-dropdowns";
import {FormButtonComponent} from "../../../shared/elements/form-button/form-button.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {FormInputComponent} from "../../../shared/elements/form-input/form-input.component";
import {FormDropdownComponent} from "../../../shared/elements/form-dropdown/form-dropdown.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {arrayValidator} from "../../../shared/validators/array.directive";
import {LanguageService} from "../../../shared/services/language.service";
import {ContentComponent} from "../../../shared/elements/content/content.component";
import {DocumentService} from "../../../shared/services/document.service";
import {ItemDocumentsPreviewSelectedComponent} from "../item-documents-preview-selected/item-documents-preview-selected.component";
import {ItemDocumentsFolderComponent} from "../item-documents-folder/item-documents-folder.component";
import {ItemDocumentsPreviewAvailableComponent} from "../item-documents-preview-available/item-documents-preview-available.component";

@Component({
    selector: 'app-dialog-documents-commander',
    imports: [
        DialogModule,
        HeadlineComponent,
        TooltipComponent,
        DropDownListModule,
        FormButtonComponent,
        TooltipModule,
        TranslatePipe,
        FormInputComponent,
        FormDropdownComponent,
        ContentComponent,
        ItemDocumentsPreviewSelectedComponent,
        ItemDocumentsFolderComponent,
        ItemDocumentsPreviewAvailableComponent
    ],
    templateUrl: './dialog-documents-commander.component.html',
    styleUrl: './dialog-documents-commander.component.scss'
})
export class DialogDocumentsCommanderComponent implements OnInit {
  public dialogService: DialogService = inject(DialogService);
  public documentService: DocumentService = inject(DocumentService);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private languageService: LanguageService = inject(LanguageService);

  @Input() public visible: boolean = false;
  @Input() public files: TYPE.Document[] = [];
  @Input() public view: 'dialog' | 'component' = 'dialog';
  @Input() public type: 'image' | 'media' | 'attachment' | 'both' = 'both';
  @Output() public  visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public  filesChange: EventEmitter<TYPE.Document[]> = new EventEmitter<TYPE.Document[]>();

  public fileList: TYPE.Document[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public searchFilterOptions: any[] = [{id: 'all', name: this.languageService.getTranslationByKey('FILESANDFOLDERS')}, {id: 'file', name: this.languageService.getTranslationByKey('FILES')}, {
    id: 'folder',
    name: this.languageService.getTranslationByKey('FOLDERS')
  }];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public searchFileTypesOptions: any[] = [];
  public documentsCommanderForm: FormGroup = this.formBuilder.group({
    searchString: [''],
    searchFilter: ['all', [Validators.required, arrayValidator(this.searchFilterOptions.map(item => item.id))]],
    searchFileTypes: ['all', [Validators.required, arrayValidator(this.searchFileTypesOptions.map(item => item.id))]],
  });
  public currentFolder: TYPE.Folder | null = null;
  private page: number = 0;
  private dialogInstance: Dialog | null = null;
  //TODO: this component should only display directly the content of the My Templates folder for now! The documentent management should not be implemeneted yet and it will be a subject of discussion, whether we need it or not.
  public ngOnInit(): void {
    if (this.type === 'media') {
      this.searchFileTypesOptions = [{id: 'all', name: this.languageService.getTranslationByKey('ALLFILES')}, {id: 'images', name: this.languageService.getTranslationByKey('IMAGES')}, {
        id: 'videos',
        name: this.languageService.getTranslationByKey('VIDEOS')
      }];
    } else if (this.type === 'attachment') {
      this.searchFileTypesOptions = [{id: 'all', name: this.languageService.getTranslationByKey('ALLFILES')}, {id: 'excel', name: this.languageService.getTranslationByKey('MICROSOFTEXCEL')}, {
        id: 'word',
        name: this.languageService.getTranslationByKey('MICROSOFTWORD')
      }, {id: 'other', name: this.languageService.getTranslationByKey('OTHER')}, {id: 'pdf', name: this.languageService.getTranslationByKey('PDF')}];
    } else {
      this.searchFileTypesOptions = [{id: 'all', name: this.languageService.getTranslationByKey('ALLFILES')}, {id: 'images', name: this.languageService.getTranslationByKey('IMAGES')}, {
        id: 'excel',
        name: this.languageService.getTranslationByKey('MICROSOFTEXCEL')
      }, {id: 'word', name: this.languageService.getTranslationByKey('MICROSOFTWORD')}, {id: 'other', name: this.languageService.getTranslationByKey('OTHER')}, {
        id: 'pdf',
        name: this.languageService.getTranslationByKey('PDF')
      }, {id: 'videos', name: this.languageService.getTranslationByKey('VIDEOS')}];
    }

    this.loadFolderDocuments();
  }

  public close(): void {
    this.visibleChange.emit(false);
  }

  public folderBack(): void {
    this.loadFolderDocuments();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public filterChanged(): void { }

  public selectFolder(folder: TYPE.Folder): void {
    console.log('selectFolder', folder);
    this.currentFolder = folder;
  }

  private loadFolderDocuments(): void {
    this.currentFolder = {
      id: 0,
      name: '',
      parent_id: 0,
      count: 0,
      documents: [
        {
          "id": 8805867,
          "type": "image",
          "path": "/files/2/intranet/20240730080937_1_image_3A1000023468.jpeg",
          "preview": null,
          "filename": "20240730080937_1_image_3A1000023468.jpeg",
          "mimetype": "image/jpeg",
          "height": 1280,
          "width": 576,
          "size": 97914
        },
        {
          "id": 12354045,
          "type": "file",
          "path": "/files/2/intranet/20250128124019_97656_Die_Mitarbeiter_App_Designvorgaben_Oktober_22.pdf",
          "preview": "/files/2/intranet/20250128124019_97656_Die_Mitarbeiter_App_Designvorgaben_Oktober_22.png",
          "filename": "20250128124019_97656_Die_Mitarbeiter_App_Designvorgaben_Oktober_22.pdf",
          "mimetype": "application/pdf",
          "height": null,
          "width": null,
          "size": 471199
        }
      ],
      folders: [
        {
          id: 2,
          name: 'My Templates',
          parent_id: 0,
          count: 12,
          documents: [
            {
              "id": 12389409,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_4508669.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_4508669.jpeg",
              "mimetype": "image/jpeg",
              "height": 1280,
              "width": 853,
              "size": 514998
            },
            {
              "id": 12389406,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_2561628.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_2561628.jpeg",
              "mimetype": "image/jpeg",
              "height": 1067,
              "width": 1600,
              "size": 384801
            },
            {
              "id": 12389405,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_2834173.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_2834173.jpeg",
              "mimetype": "image/jpeg",
              "height": 1068,
              "width": 1600,
              "size": 296550
            },
            {
              "id": 12389402,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_313691.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_313691.jpeg",
              "mimetype": "image/jpeg",
              "height": 1200,
              "width": 1600,
              "size": 184747
            },
            {
              "id": 12389403,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_2975498.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_2975498.jpeg",
              "mimetype": "image/jpeg",
              "height": 898,
              "width": 1600,
              "size": 236398
            },
            {
              "id": 12389407,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_919109.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_919109.jpeg",
              "mimetype": "image/jpeg",
              "height": 1064,
              "width": 1600,
              "size": 376568
            },
            {
              "id": 12389401,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_355948.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_355948.jpeg",
              "mimetype": "image/jpeg",
              "height": 973,
              "width": 1600,
              "size": 175898
            },
            {
              "id": 12389404,
              "type": "image",
              "path": "/files/2/intranet/20250130153616_1_pexels_photo_1464223.jpeg",
              "preview": null,
              "filename": "20250130153616_1_pexels_photo_1464223.jpeg",
              "mimetype": "image/jpeg",
              "height": 1067,
              "width": 1600,
              "size": 268869
            }
          ],
          folders: []
        },
        {
          id: 3,
          name: 'Recent uploaded',
          parent_id: 0,
          count: 73,
          documents: [],
          folders: []
        }
      ]
    }
  }

  public update(): void {
    this.filesChange.emit(this.files);
  }
}
